module.exports = __webpack_public_path__ + "img/face-fearful.7cd89053.svg";